export default class Card{
    description: string;
    firm: boolean;
    price: number;
    url: string;
    id: number;

    constructor(description: string, firm: boolean, price: number, url: string, id: number){
        this.description = description;
        this.firm = firm;
        this.price = price;
        this.url = url;
        this.id = id;

    }


}